import React from "react";
import PropTypes from "prop-types";

function NoData({ className }) {
    return (
        <div className={"text-center " + className} tabIndex="0">
            <p className="mb-0 pb-3p ">No Data</p>
        </div>
    );
}

NoData.propTypes = {
    className: PropTypes.string
}

export default NoData;
